import React, { useState, useCallback} from 'react';
import LFOToggle from './LFOToggle.js';
import EnvelopeToggle from './EnvelopeToggle.js';

export default function ParameterModulators(props) {
    let lfos = props.sequencerEngine.lfosTrack.lfos.map(lfo => lfo.lfo);
    let envelopes = props.sequencerEngine.envelopes;
    return (
        <div className="parameter-modulators">
          <div className="lfo-buttons">
            {lfos.map(lfo => 
                      <LFOToggle 
                            lfo={lfo}
                            lfos={lfos}
                            parameter={props.parameter}/>)}
          </div>
          <div className="envelope-buttons">
            {envelopes.map(
                (envelope, i) =>
                    <EnvelopeToggle 
                parameter={props.parameter}
                envelope={envelope}
                envelopes={envelopes}
                    />)}
          </div>
        </div>
    );
}
